<template>
    <div class="aside content">
        <div>
            <div class="side-list">

                <template>
                    <div class="side-back" v-if="userInfo.identity==='CUSTOMER'" @click="handleSelect('/user?sider=true')">
                            <p><i  class="iconfont icon-fanhui1" ></i>返回列表</p>
                    </div>
                    <div class="side-back" v-if="userInfo.identity==='USER'" @click="handleSelect('services.leemma.com')">
                        <p><i  class="iconfont icon-fanhui1" ></i>返回后台</p>
                    </div>


                    <div v-if="router==='MTEMP'&&item.show"  @click="handleSelect(item.path)" v-for="(item,index) in sideList.MtempControl" :key='item.path' class="side-item"
                         :class="{'is-active':$route.path==item.path}">
                        <p>
                            <i  class="iconfont" :class="item.icon"></i>{{item.name}}</p>
                    </div>
                    <div v-if="router==='WATER'&&item.show" @click="handleSelect(item.path)"
                         v-for="(item,index) in sideList.allocateWater" :key='item.path' class="side-item"
                         :class="{'is-active':$route.path==item.path}">
                        <p>
                            <i   class="iconfont" :class="item.icon"></i>{{item.name}}</p>
                    </div>
                </template>
                <div style="width: 15px">
                    &nbsp;
                </div>

            </div>
        </div>
        <transition name="el-zoom-in-top">
            <div  v-if="msgTool.show" class="msg-tool">
                <div class="msg-tool-input">
                    <el-input
                        type="textarea"
                        :rows="3"
                        placeholder="请输入内容"
                        :maxlength="64"
                        v-model="msgTool.msg">
                    </el-input>
                </div>
                <div>
                    <p @click="setDeviceMsg "><el-button :loading="msgTool.loading" type="text">{{msgTool.loading?'':'发送'}}</el-button></p>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    const image_logo = require("../../assets/images/leemma logo.png");
    const image_logo_64 = require("../../assets/images/leemma64x64.png");
    // TODO 侧边栏的收回
    import { mapState } from "vuex";
    import Lib from "../../lib/lib";

    export default {
        name: "pageSide",
        data() {
            return {
                image_logo,
                image_logo_64,
                activeIndex: "",
                router: this.$route.hash,
                isshow: true,
                scrolled:"",
                msgTool: {
                    show: false,
                    msg: "",
                    sys_alias: "1",
                    loading: false
                },
                sideList: {
                    user: [
                        { path: "/user/deviceList", name: "设备列表",Mname:'设备', icon: "icon-all" }
                        // { path: '/user/msgList', name: '消息中心', icon: 'icon-tixing' },
                        // { path: '/user/setting', name: '账号设置', icon: 'icon-setup_fill' },
                    ],
                    tempControl: [
                        {
                            path: "/tempControl/realData",
                            name: "工艺曲线",Mname:'工艺',
                            icon: "icon-shishibaobiao"
                        },
                        {
                            path: "/tempControl/historyData",
                            name: "产量统计",Mname:'产量',
                            icon: "icon-xiangxi"
                        },
                        {
                            path: "/tempControl/controlSet",
                            name: "控制参数",Mname:'控制',
                            icon: "icon-xitongcanshushezhi"
                        },
                        {
                            path: "/tempControl/standardSet",
                            name: "标准参数",Mname:'标准',
                            icon: "icon-leijianzhuxiulix"
                        },

                        {
                            path: "/tempControl/autoVal",
                            name: "控制变量",Mname:'变量',
                            icon: "icon-text",
                            identity: "USER"
                        },
                        {
                            path: "/tempControl/deviceConf",
                            name: "设备配置",Mname:'配置',
                            icon: "icon-sitting",
                            identity: "USER"
                        }
                    ],
                    MtempControl: [
                        {
                            path: "/MtempControl/realData",
                            name: "工艺曲线",Mname:'工艺',
                            icon: "icon-shishibaobiao"
                        },
                        {
                            path: "/MtempControl/historyData",
                            name: "产量统计",Mname:'产量',
                            icon: "icon-xiangxi"
                        },
                        {
                            path: "/MtempControl/controlSet",
                            name: "控制参数",Mname:'控制',
                            icon: "icon-xitongcanshushezhi"
                        },
                        {
                            path: "/MtempControl/standardSet",
                            name: "标准参数",Mname:'标准',
                            icon: "icon-leijianzhuxiulix"
                        },

                        {
                            path: "/MtempControl/autoVal",
                            name: "控制变量",Mname:'变量',
                            icon: "icon-text",
                            identity: "USER"
                        },
                        {
                            path: "/MtempControl/deviceConf",
                            name: "设备配置",Mname:'配置',
                            icon: "icon-sitting",
                            identity: "USER"
                        },
                        {
                            path: "message",
                            name: "发送消息",Mname:'消息',
                            icon: "icon-youjian"
                        },

                    ],
                    allocateWater: [
                        {
                            path: "/allocate/realData",
                            name: "实时数据",Mname:'实时',
                            icon: "icon-shishibaobiao",
                        },
                        {
                            path: "/allocate/outputData",
                            name: "统计报告",Mname:'统计',
                            icon: "icon-xiangxi"
                        },
                        {
                            path: "/allocate/controlConf",
                            name: "控制参数",Mname:'控制',
                            icon: "icon-xitongcanshushezhi"
                        },
                        {
                            path: "/allocate/standConf",
                            name: "标准参数",Mname:'标准',
                            icon: "icon-leijianzhuxiulix"
                        },
                        {
                            path: "/allocate/autoVal",
                            name: "控制变量",Mname:'变量',
                            icon: "icon-text",
                            identity: "USER"
                        },
                        {
                            path: "/allocate/deviceConf",
                            name: "设备配置",Mname:'配置',
                            icon: "icon-sitting",
                            identity: "USER"
                        },
                        {
                            path: "message",
                            name: "发送消息",Mname:'消息',
                            icon: "icon-youjian"
                        }
                    ],
                    bottom: [
                        {
                            path: "/user?sider=true",
                            name: "返回列表",Mname:'列表',
                            icon: "icon-undo",
                            identity: "CUSTOMER"
                        },
                        {
                            path: "/logout/",
                            name: "退出登录",Mname:'退出',
                            icon: "icon-tuichu",
                            identity: "CUSTOMER"
                        },
                        {
                            path: "services.leemma.com",
                            name: "返回管理后台",Mname:'返回',
                            icon: "icon-tuichu",
                            identity: "USER"
                        }
                    ]
                }
            };
        },
        computed: mapState({
            isOpen: function(state) {
                return state.siderbarOpen;
            },
            isMobile: state => state.isMobile,
            userInfo: state => state.userInfo,
            devceInfo: state => state.deviceInfo
        }),
        created() {
            this.showRouteName();
        },
        mounted(){
            //监听滚动
            // window.addEventListener('scroll', this.handleScroll);
        },
        watch: {
            $route: "showRouteName"
        },
        methods: {
            handleScroll () {
                this.scrolled = window.scrollY;
                console.log(  window.scrollY)
            },
            listenScoll(){

            },
            handleSelect(keyPath, ele) {
                //logout
                if (keyPath === "logout") {
                    this.logout();
                } else if (keyPath === "services.leemma.com") {
                    location.href = "https://services.leemma.com";
                } else if (keyPath === "message") {
                    this.toggleMsgTool();
                } else {
                    this.$router.push(keyPath);
                }
                //手机端隐藏侧栏
                if (this.isMobile) {
                    this.$store.dispatch("toggleSide");
                }
            },
            toggleMsgTool() {
                let msgTool = this.msgTool;
                msgTool.show = !msgTool.show;
                let msgObj = this.sideList.MtempControl[6];
                if (this.router === "WATER" && this.sideList.allocateWater.length>=7){
                    msgObj = this.sideList.allocateWater[6];
                }
                if (msgTool.show){
                    msgObj.name="关闭";
                }else{
                    msgObj.name="发送消息";
                }

            },

            setDeviceMsg() {
              this.msgTool.loading = true;
              let params = {
                payload: JSON.stringify({
                  msg: this.msgTool.msg,
                  devNo: this.msgTool.sys_alias * 1
                }),
                sys_alias: this.msgTool.sys_alias,
                device_id: this.devceInfo.device_id
              };
              if (this.userInfo.identity === "USER") {
                params.auth_token = this.userInfo.token;
              } else {
                params.customer_token = this.userInfo.token;
              }
              Lib.api.setDeviceMsg(params, data => {
                this.msgTool.loading = false;
                this.msgTool.show = false;
                if (data.status_code === "SUCCEEDED") {
                  this.$message.success("发送成功");
                } else {
                  this.$message.error("操作失败");
                }
                this.toggleMsgTool();
              });
            },
            // 检测权限
            checkIdentity(arr) {
                arr.forEach(item => {
                    if (item.identity === "USER" && this.userInfo.identity !== "USER") {
                        item.show = false;
                    } else {
                        item.show = true;
                    }

                    if (item.identity === "ONLYCUSTOMER" && this.userInfo.identity !== "CUSTOMER") {
                        item.show = false;
                    }
                    if(this.devceInfo.category==='配煤'&&item.name==='控制参数'){
                        item.show=false
                    }
                    if(this.devceInfo.category==='配水'&&item.name==='标准参数'){
                        item.show=false
                    }
                    if(!this.isMobile&&item.name==='发送消息'){
                        item.show=false
                    }
                }, this);
            },
            // 登出并跳转到登陆页
            logout() {
                let params = {
                    customer_token: this.userInfo.token
                };
                Lib.api.logout(params, data => {
                    this.$message("登出成功");
                });
            },
            showRouteName() {
                let routeSearch = text => {
                    if (this.$route.path.search(text) === 1) {
                        return true;
                    } else {
                        return false;
                    }
                };
                if (routeSearch("tempControl")) {
                    this.router = "TEMP";
                } else if (routeSearch("allocate")) {
                    this.router = "WATER";
                    this.changeTitle(this.devceInfo.name)
                }else if(routeSearch("MtempControl")){
                    this.router='MTEMP';
                    this.changeTitle(this.devceInfo.name)
                } else {
                    this.router = "USER";
                    this.changeTitle('设备列表')
                }
                this.checkIdentity(this.sideList.tempControl);
                this.checkIdentity(this.sideList.MtempControl);
                this.checkIdentity(this.sideList.allocateWater);

            },
            changeTitle(title){
                let body = document.getElementsByTagName('body')[0];
                document.title = title;
                let iframe = document.createElement("iframe");
                iframe.style.display="none";
                let d = function() {
                    setTimeout(function() {
                        iframe.removeEventListener('load', d);
                        document.body.removeChild(iframe);
                    }, 0);
                };
                iframe.addEventListener('load', d);
                document.body.appendChild(iframe);
            }
        }
    };
</script>

<style scoped>
    .content {
        /*z-index: 1;*/
        box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.15);
        /*position: fixed;*/
        /*top: 0px;*/
        /*left: 0;*/
        background: #2378DC;
        width: 100%;
        height: 50px;
      overflow: auto;

    }

    .logo img {
        width: 94%;
        margin: 14px 0;
    }
        .side-list{
            display: flex;
            overflow: scroll;
            align-items: center;
            height: 50px;
        }
    .side-item {
        font-size: 0.13rem;
        line-height: 28px;
        color: #fff;
        padding: 0 10px;
        margin: 0 4px;
        border: 1px solid;
        border-radius: 2px;
        cursor: pointer;
        position: relative;
        box-sizing: border-box;
        white-space: nowrap;
/*        background-image: url("../../assets/images/M-siderbar-button-raised.png") ;
        background-size:cover ;*/
    }
    .side-back{
        font-size: 0.13rem;
        line-height: 28px;
        color: #fff;
        padding: 0 5px;
        margin: 0 5px;
        cursor: pointer;
        position: relative;
        box-sizing: border-box;
        white-space: nowrap;
    }
    .side-back .iconfont {
        font-size: 0.13rem;
        vertical-align: baseline;
        margin: 0  10px 0 0px;
        text-align: center;
    }

    .side-item .iconfont {
        font-size: 0.13rem;
        vertical-align: baseline;
        margin: 0 30px 0 10px;
        text-align: center;
    }

    .side-item p {
        display: flex;
        align-items: center;
    }

    .side-item.is-active {
        color: #2378dc;
        background-color: #fff;
        border-color: #fff;
        /*background-image: url("../../assets/images/M-siderbar-button-concave.png") ;*/

    }



    .msg-tool-button {
      /*background: rgba(84,84,84,1);*/
      position: relative;
    }

    .msg-tool {
      background: rgba(84, 84, 84, 1);
      border-radius: 5px;
      position: absolute;
      top: 60px;
      left: 10px;
      right: 10px;
      z-index: 11999;
      display: flex;
      padding: 10px;
      align-items: center;
    }

    .msg-tool > div button {
      color: white;
      margin-left: 10px;
      background-color: none!important; 
    }

    .msg-tool > div button:before {
      background: none!important; 
    }

    .msg-tool > div:first-child {
      width: 500px;
    }

    .msg-tool > div:last-child {
      width: 100px;
      text-align: center;
      cursor: pointer;
    }

    @media (max-width: 800px) {
        .side-item .iconfont {
            vertical-align: baseline;
            margin: 0 5px 0 0;
            text-align: center;
        }

        .side-item {
            padding: 2px 10px 0 ;
        }

        .logo > img {
            margin: 11px auto;
            display: block;
            width: 63%;
        }


        .msg-tool > div:first-child {
            width: 85%;
        }

        .msg-tool > div:last-child {
            width: 15%;
            text-align: center;
            cursor: pointer;
        }
    }
</style>



// WEBPACK FOOTER //
// MpageSide.vue?7f7ce12c